webpackJsonp([237455716749238],{

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var projectElements = {
		images: [{
			"src": "AnalogAlphabet/art",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/broken",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/childhood",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/dirt",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/exit",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/fire",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/glass",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/house",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/i",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/joy",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/kitchen",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/lost",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/mirror",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/newspaper",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/odd",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/people",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/quiet",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/rain",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/snail",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/trangle",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/uni",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/vibration",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/water",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/x",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/yellow",
			"orientation": "landscape"
		}, {
			"src": "AnalogAlphabet/zero",
			"orientation": "landscape"
		}]
	};
	
	var Paper = function (_React$Component) {
		_inherits(Paper, _React$Component);
	
		function Paper() {
			_classCallCheck(this, Paper);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Paper.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Analog Alphabet',
				text: 'Anstatt Fotos f\xFCr nur ein bestimmtes Thema zu machen, wollte ich mir die M\xF6glichkeit geben viele kleine Bildthemen zu haben. Dieses Konzept hat mit mehr Freiheiten innerhalb eines Projektes gegeben. 26 Buchtaben, 26 W\xF6rter und 26 Bilder.',
				images: projectElements.images });
		};
	
		return Paper;
	}(_react2.default.Component);
	
	exports.default = Paper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-alphabet-js-47d44abce04ef875fe83.js